import React, { useMemo } from "react";
import { DollarSign, X } from "lucide-react";
import {
  buildSubscriptionCheckoutUrl,
  // SUBSCRIPTION_CHECKOUT_URL_11,
  SUBSCRIPTION_CHECKOUT_URL_200,
  SUBSCRIPTION_CHECKOUT_URL_500,
  SUBSCRIPTION_CHECKOUT_URL_800,
  SUBSCRIPTION_CHECKOUT_URL_100,
  SUBSCRIPTION_CHECKOUT_URL_201_NO_FREE_TRIAL,
} from "../hooks/useDashboardSubscriptionModal";
import subscriptionNoFreeTrialUsers from "../config/subscriptionNoFreeTrialUsers.json";

const SUBSCRIPTION_PLANS_WITH_FREE_TRIAL = [
  // { price: 11, href: SUBSCRIPTION_CHECKOUT_URL_11 },
  { price: 99, href: SUBSCRIPTION_CHECKOUT_URL_100, planNumber: 1 },
  { price: 199, href: SUBSCRIPTION_CHECKOUT_URL_200, planNumber: 2 },
  { price: 499, href: SUBSCRIPTION_CHECKOUT_URL_500, planNumber: 5 },
  { price: 799, href: SUBSCRIPTION_CHECKOUT_URL_800, planNumber: 8 },
];

const SUBSCRIPTION_PLANS_NO_FREE_TRIAL = [
  { price: 199, href: SUBSCRIPTION_CHECKOUT_URL_201_NO_FREE_TRIAL, planNumber: 201 },
];

const isNoFreeTrialUser = (user) => {
  const email = user?.email?.trim().toLowerCase();
  if (!email) return false;
  return subscriptionNoFreeTrialUsers.userEmails.some(
    (listedEmail) => String(listedEmail).trim().toLowerCase() === email
  );
};

const SubscriptionPlansModal = ({
  isOpen,
  isDisabledForUser,
  user,
  currentPlanNumber,
  onClose,
  storeId,
}) => {
  const subscriptionPlans = useMemo(
    () =>
      isNoFreeTrialUser(user)
        ? SUBSCRIPTION_PLANS_NO_FREE_TRIAL
        : SUBSCRIPTION_PLANS_WITH_FREE_TRIAL,
    [user]
  );

  if (!isOpen || !user || !storeId) return null;

  return (
    <div
      className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-[220]"
      aria-hidden
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-2xl border border-slate-200 shadow-2xl max-w-md w-full overflow-hidden"
        onClick={(event) => event.stopPropagation()}
      >
        {isDisabledForUser && (
          <button
            type="button"
            aria-label="Close subscription modal"
            onClick={onClose}
            className="absolute top-3 right-3 p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        )}
        <div className="p-5 text-center pr-12 bg-slate-50 border-b border-slate-200 mb-2">
          <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-blue-100 flex items-center justify-center">
            <DollarSign className="w-7 h-7 text-blue-600" />
          </div>
          <h3 className="text-lg font-bold text-slate-900 mb-2">
            Choose your plan
          </h3>
          <p className="text-slate-500 text-sm">
            Pick the option that works for your store.
          </p>
        </div>

        <div className="px-4 pb-4 bg-white space-y-2">
          {subscriptionPlans.map(({ price, href, planNumber }, index) => (
            <a
              key={index}
              href={
                planNumber == currentPlanNumber
                  ? undefined
                  : buildSubscriptionCheckoutUrl(href, storeId)
              }
              target="_blank"
              rel="noopener noreferrer"
              data-tip={planNumber == currentPlanNumber ? "This is the plan your store is on now" : "Opens checkout for this plan in a new tab"}
              className="w-full py-3 px-4 rounded-xl bg-white border border-slate-200 text-slate-700 font-semibold hover:bg-slate-100 transition-colors flex items-center justify-between"
            >
              <span className="font-semibold">${price} {planNumber !== 201 ? '- The first month is free' : ''}</span>
              <span className="text-blue-600 text-sm font-medium">
                {planNumber == currentPlanNumber ? 'Current plan' : 'Subscribe now'}
              </span>
            </a>
          ))}
          {isDisabledForUser && (
            <button
              type="button"
              onClick={onClose}
              className="w-full py-2.5 px-4 rounded-xl text-slate-500 font-medium hover:bg-slate-100 transition-colors"
            >
              Maybe later
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlansModal;
